export default "__VITE_ASSET__74632690__"